
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import styled from '@emotion/styled';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormHelperText, MenuProps, SxProps, Theme } from '@mui/material';
import { COLOR_MAP } from '../../constants/ColorNames';
import CommonTooltip from './CommonTooltip';

type DropDownSelect = {
    id: string,
    selectedValue?: string,
    handleChange: (e: SelectChangeEvent<unknown>) => void,
    listItems: {
      label: string;
      value?: string;
      isDisabled?: boolean;
      additionalInfoHorizontal?: string,
    }[],
    placeholder?: string,
    label: string,
    value?: string,
    showError?: boolean, 
    errorMessage? : string, 
    inputProps?: any,
    sx? : SxProps<Theme> | undefined
    startAdornment? : React.ReactNode,
    autoWidth?: boolean,
    MenuProps?: Partial<MenuProps>,
    isDisabled?:boolean
}

const StyledSelect = styled(Select)`

    &.MuiInputBase-root {
       padding: 0

    }
`
const SingleSelectDropDown = (props: DropDownSelect) => {
    const { id, selectedValue = '', handleChange, listItems, placeholder, value, label, showError, errorMessage, inputProps, sx,startAdornment, autoWidth, MenuProps, isDisabled = false  } = props

    return (
    <FormControl sx={{ m: 0, width: '100%' }} size="small">
        <StyledSelect
            IconComponent={ExpandMoreIcon}
            startAdornment={startAdornment}
            displayEmpty
            renderValue={() => selectedValue ? selectedValue : placeholder}
            id={id}
            onChange={handleChange}
            value={selectedValue}
            error={showError}
            inputProps={inputProps}
            disabled={isDisabled}
            sx={{
                ...sx, 
                "& .MuiSelect-select": {
                    padding: "0px !important",
                },
                // "&.Mui-disabled":{
                //     backgroundColor:'#F6F6F7',
                //     "& fieldset": {
                //         border: "none",
                //         },
                // }
            }}
            autoWidth={autoWidth}
            MenuProps={MenuProps}
            // helperText={errorMessage}
        >
          {listItems.length > 0 && listItems.map((list, index) => (
              <MenuItem
                  sx={{
                      padding: '1.2rem 0.8rem !important',
                      display: list.isDisabled ? 'none' : 'block'
                  }}
                  value={list.value}
                  disabled={list.isDisabled}
                  >
                  {list.label}
                  {list.additionalInfoHorizontal && (
                        <span style={{ marginLeft: 2, color: COLOR_MAP.GREY_DARK }}>
                            {list.additionalInfoHorizontal}
                        </span>
                    )}
              </MenuItem>
          ))}
        </StyledSelect>
        {errorMessage ? <FormHelperText>{errorMessage}</FormHelperText> : null}
    </FormControl >
    )
}

export default SingleSelectDropDown